var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoadmapleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 307.75,
    height: 348.816,
    viewBox: "0 0 307.75 348.816",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60022",
    "data-name": "Group 60022",
    transform: "translate(-230.25 -409.684)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    y2: 348.816,
    transform: "translate(385.5 409.684)",
    fill: "none",
    stroke: "#16ebc3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60018",
    "data-name": "Group 60018",
    transform: "translate(230.25 580.683)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x1: 306.5,
    transform: "translate(1.25 7.5)",
    fill: "none",
    stroke: "#16ebc3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_3ffd845dc095e0b7ed68934bdd3cf0a2",
    "data-name": "3ffd845dc095e0b7ed68934bdd3cf0a2",
    d: "M8.7.326c.01.012.014.028.024.04L15.708,8.08a1.2,1.2,0,0,1,0,1.572.042.042,0,0,1-.012.008.936.936,0,0,1-.712.34H1.019A.948.948,0,0,1,.3,9.648l0,0a1.2,1.2,0,0,1,0-1.572l7-7.754A.928.928,0,0,1,8.7.326Z",
    transform: "translate(0 16.001) rotate(-90)",
    fill: "#16ebc3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "d512776bbd823464640325b1e2ba6ddd",
    transform: "translate(364.303 562.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    d: "M38.04,12.371,20.9,22.282,3.77,12.371a4.122,4.122,0,0,1,1.457-1.478l13.6-7.849a4.239,4.239,0,0,1,4.164,0l13.6,7.849a4.131,4.131,0,0,1,1.457,1.478Z",
    transform: "translate(0.292 0)",
    fill: "#16ebc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    d: "M21.2,17.15V36.929a4.351,4.351,0,0,1-1.895-.437L5.582,28.56a4.17,4.17,0,0,1-2.082-3.6V9.343a4.289,4.289,0,0,1,.562-2.1Z",
    transform: "translate(0 5.131)",
    fill: "#1042f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    d: "M29.7,9.343V24.958a4.17,4.17,0,0,1-2.082,3.6L13.832,36.513A4.358,4.358,0,0,1,12,36.929V17.15L29.135,7.24A4.307,4.307,0,0,1,29.7,9.343Z",
    transform: "translate(9.197 5.131)",
    fill: "#af49ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapleft);
export default __webpack_public_path__ + "static/media/roadmapleft.94e80e0a7e4522c9f6245855d887fd6e.svg";
export { ForwardRef as ReactComponent };